import React, { useState, useEffect } from 'react';
import Head from 'next/head';
import PropTypes from 'prop-types';
import mixpanel from '@/lib/util/mixpanel';
import {
  Container, Col, Row, Button, Spinner,
} from 'react-bootstrap';

import Layout from '@/components/common/layouts/Layout';
import UserAPI from '@/lib/api/UserAPI';
import { useUserContext } from '@/lib/context/useUserContext';

const propTypes = {
  query: PropTypes.objectOf({
    email: PropTypes.string.isRequired,
    token: PropTypes.string.isRequired,
  }).isRequired,
};

function Verify({ query: { email, token } }) {
  const [statusText, setStatusText] = useState('Verifying your account... If this is taking a while, try refreshing the page.');
  const [isLoading, setIsLoading] = useState(true);
  const [verified, setVerified] = useState(false);
  const { signIn } = useUserContext();
  if (email) window.analytics.identify(email);

  useEffect(() => {
    UserAPI.verify(email, token)
      .then(({ message, user }) => {
        window.analytics.track('Verified');
        setStatusText(message);
        signIn(user, { noRedirect: true });
        setIsLoading(false);
        setVerified(true);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
        setStatusText(err.message);
        setVerified(false);
      });
  }, [email, token]);

  const StatusBox = ({ verified }) => (verified
    ? (
      <>
        <br />
        <br />
        <br />
        <img src="images/onboarding/email-verified.svg" alt="success" width="250px" />
        <br />
        <br />
        <h1 style={{ fontSize: '32px' }}>Welcome to Big & Mini!</h1>
        <p style={{ color: 'gray', fontSize: '20px' }}>Your email was verified successfully.</p>
      </>
    )
    : (
      <>
        <br />
        <br />
        <br />
        <img src="images/onboarding/access_denied.svg" alt="invalid link" width="250px" />
        <br />
        <br />
        <h1 style={{ fontSize: '32px' }}>Unable to verify email. </h1>
        <p style={{ color: 'gray', fontSize: '20px' }}>{statusText}</p>
      </>
    ));

  return (
    <Layout>
      <Head>
        <title>Big & Mini | Verify Email</title>
      </Head>
      <div className="fill-height">
        <Container>
          <Row className="justify-content-md-center" style={{ textAlign: 'center', paddingTop: '10vh' }}>
            <Col md={12}>
              {isLoading
                ? <Spinner size="lg" color="blue" animation="border" />
                : (
                  <StatusBox verified={verified} />
                )}

            </Col>
            <div style={{ textAlign: 'center' }}>
              <p>
                {
                verified
                  ? <Button href="dashboard">Go to Dashboard</Button>
                  : null
              }

              </p>
            </div>
          </Row>
        </Container>
      </div>
    </Layout>
  );
}

Verify.getInitialProps = ({ query }) => ({ query });

Verify.propTypes = propTypes;
export default Verify;
